import $ from 'jquery'
import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import FolderOverview from './charts-folder-overview'
import viewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'
import i18n from 'scoreboard/components/i18n'
import globals from 'scoreboard/components/globals'
import BaseRouter from '../components/base-router'
import ChartsEdit from './edit/charts-edit'
import ChartsOverview from './charts-overview'
import ChartsNav from './charts-nav'
import chartsHeader from './charts-header'
import Chart from './model/chart'
import FolderForm from 'scoreboard/components/folder-form'
import getCreateFolderFunction from 'scoreboard/components/get-create-folder-function'
import CannotEditCopyView from 'scoreboard/components/designer/cannot-edit-copy-view'
import exportState from 'scoreboard/components/export/export-state'
import persistedViewState from 'scoreboard/components/persisted-view-state'
import EmptyState from 'scoreboard/components/empty-state'

const ChartsRouter = BaseRouter.extend({
	Nav: ChartsNav,
	Model: Chart,
	section: 'charts',

	routes: {
		'organizations/:orgId/charts/new(/)': 'createFirst',
		'organizations/:orgId/charts/new-folder(/)': 'createFirstFolder',
		'charts(/:id)/new-folder(/)': 'createFolder',
		'charts/:relativeId/new(/)': 'create',
		'charts/:id/edit(/)': 'edit',
		'charts/:id/export(/)': 'export',
		'charts/:id(/)?state=:state': 'overview',
		'charts/:id(/)': 'overview'	//should be last as its url is the least specific
	},

	overview: function (id, stateString) {
		let state = persistedViewState(stateString)
		console.log('state', state)

		function stringifyOrNull(obj) {
			return obj ? JSON.stringify(obj) : null
		}

		let options = _.extend({
			calendarPeriodId: globals.periodId,
			templateInfo: true,
			subscriptions: true,
			drilldownId: stringifyOrNull(state?.drilldownId),
			liveFilters: stringifyOrNull(state?.liveFilters),
			zoomToIds: stringifyOrNull(state?.zoomToIds),
		})

		let viewOptions = { exportState: state }

		this._route(id, globals.orgId, FolderOverview, ChartsOverview, false,
			options, viewOptions)
	},

	export: function(id) {
		this.overview(id)
	},

	edit: function(id) {
		if (this.handleNoCalendars({ heading: i18n.get('charts.charts')})) {
			return
		}

		let options = {
			calendarPeriodId: globals.periodId,
			templateInfo: true,
			subscriptions: true
		}

		this._route(id, globals.orgId, FolderForm, ChartsEdit, true, options)
	},

	createFirst: function (orgId) {
		this.create(null, orgId)
	},

	create: function (relativeId, orgId) {
		if (this.handleNoCalendars({ heading: i18n.get('charts.charts')})) {
			return
		}

		$.when(this._resolveOrg(relativeId, orgId)).done(parentId => {
			let oid = orgId || globals.orgId

			let chart = Chart.create({
				organizationId: oid,
				relativeId: parentId
			})

			const navPromise = this.nav({ id: parentId, orgId: oid, toggleEditViewState: true })

			var edit = new ChartsEdit({model: chart})
			appDisplay.display(edit)
			// must go after the nav is created
			navPromise.then(() => this.addTransient(edit, parentId, chart))
		})
	},

	createFolder: getCreateFolderFunction(true, { header: 'charts.charts' }),

	createFirstFolder: function(orgId) {
		this.createFolder(null, orgId)
	},

	/**
	 * @param {Object} params parameters that should be sent with the fetch XHR
	 * @param {Object} viewOptions options that should be passed to the View constructor
	 */
	_route: function(id, orgId, folderView, chartView, navEditable, params, viewOptions) {
		// fetch & display the chart by id
		// #41027 - always fetch even when toggling between edit and view
		// https://github.com/SpiderStrategies/Scoreboard/issues/41027#issuecomment-908446126
		const modelPromise = this.load(id, params)

		appDisplay.display(modelPromise, (model) => {
			// cache the model
			this._currentModel = model
			return this._prepView({
				model, folderView, chartView, navEditable, viewOptions
			})
		})
		this._navForModel(modelPromise, id, navEditable, params)
	},

	_navForModel: function (modelPromise, id, edit, params) {
		if (id) {
			const navOptions = _.defaults({ id, edit }, params)
			this.navForModel(navOptions, modelPromise)
		}
	},

	/**
	 * @param {Object} options.viewOptions options that should be passed to the
	 * View constructor
	 */
	_prepView: function(options) {
		const {
			model,
			folderView,
			chartView,
			viewOptions,
			navEditable
		} = options

		// do not allow editing if user does not have charts and reports
		// permission (#40236)
		if (!model.isEditable() && navEditable) {
			let body = this._notEditableBody(model)
			return new EmptyState({ body, model})
		}

		if (model.get('templateId') && navEditable) {
			return new CannotEditCopyView({
				model,
				section: 'charts',
				headerFn: chartsHeader.generate
			})
		}

		let view
		if (model.get('type') === 'folder') {
			view = new folderView({
				model,
				tabs: viewEditTabs,
				overviewTabCode: 'common.view'
			})
		} else {
			view = new chartView(_.extend({
				model
			}, viewOptions))
		}

		this.setBrieferView(view)

		return view
	}
})

export default ChartsRouter

ChartsRouter.__filename__ = 'charts/charts-router.js'
